import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, sync$, useTask$, $, Slot } from "@builder.io/qwik";
import { useBoundSignal } from "../../utils/bound-signal2.qwik.mjs";
const HToggle = component$((props) => {
  const { pressed: pressedProp, onPressedChange$, "bind:pressed": givenValueSig, ...buttonProps } = props;
  const pressedSig = useBoundSignal(givenValueSig, pressedProp ? pressedProp : false);
  const handleKeyDownSync$ = sync$((event) => {
    if (![
      "ArrowRight",
      "ArrowLeft",
      "ArrowDown",
      "ArrowUp"
    ].includes(event.key))
      return;
    event.preventDefault();
  });
  useTask$(async ({ track }) => {
    if (pressedProp === void 0)
      return;
    track(() => pressedProp);
    pressedSig.value = pressedProp;
  });
  const handleClick$ = $(async () => {
    if (!props.disabled) {
      pressedSig.value = !pressedSig.value;
      if (onPressedChange$) {
        onPressedChange$(pressedSig.value);
      }
    }
  });
  return /* @__PURE__ */ jsx("button", {
    type: "button",
    "aria-pressed": pressedSig.value,
    "aria-disabled": props.disabled ? true : false,
    "data-disabled": props.disabled ? "" : void 0,
    onKeyDown$: [
      handleKeyDownSync$,
      props.onKeyDown$
    ],
    ...buttonProps,
    class: props.class,
    onClick$: [
      props.onClick$,
      handleClick$
    ],
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HToggle
};
